var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Production',{attrs:{"post":_vm.post}}),_vm._v(" "),_c('Facebook',{attrs:{"post":_vm.post}}),_vm._v(" "),_c('LinkedIn',{attrs:{"post":_vm.post}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }